import request from '@/utils/zsm-requets'
/**
 * 短信发送验证码
      mobile	手机号
      msgDict 发送类型
 */
export function sendMsgSms(mobile,msgDict) {
  return request({
    url: '/zsm/api/sms/sendMsg',
    method: 'post',
    params: {mobile,msgDict}
  })
}
